import React, { SVGProps } from "react";
export default function SupUserAnon005(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 5.37994L10 0.759888L2.00002 5.37994M18 5.37994L10 10M18 5.37994L18 7.08207L14.7577 8.95451M10 19.2401L18 14.6201L18 10.9032M10 19.2401L2.00002 14.6201V10.9032M10 19.2401V15.5232M2.00002 5.37994L10 10M2.00002 5.37994L2 7.08207L5.24228 8.95451M10 10L9.99999 11.7021M9.99999 11.7021L13.168 9.91188M9.99999 11.7021L6.84803 9.91188M10 15.5232L18 10.9032M10 15.5232L2.00002 10.9032M18 10.9032L14.7577 8.95451M2.00002 10.9032L5.24228 8.95451M5.24228 8.95451L6.84803 9.91188M14.7577 8.95451L13.168 9.91188M13.168 9.91188L14.7577 10.9032L10 13.6474L5.24228 10.9032L6.84803 9.91188"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
